import { render, staticRenderFns } from "./setting-header.vue?vue&type=template&id=49c236a8&"
import script from "./setting-header.vue?vue&type=script&lang=js&"
export * from "./setting-header.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports